/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/

// import * as polyglot from 'polyglot';
import Polyglot from 'node-polyglot';
import defaultResources from 'amdi18n-loader!./DefaultResources'; // eslint-disable-line

const StringResource = function (resources) {
	const allResources = Object.assign({}, defaultResources, resources);
    this._polyglot = new Polyglot({ phrases: allResources });
};

/**
 * Get the string resource for the given key and interpolation options
 *
 * @param key The  key of the string to return
 * @param interpolationOptions Optional interpolation options (see poly.t documentation for details)
 * @returns The string to display
 */
StringResource.prototype.get = function (key, interpolationOptions) {
    let translated = this._polyglot.t(key, interpolationOptions);
    if (this._polyglot.phrases[key] === undefined) {
        translated = `__NOT_TRANSLATED__(${key})`;
    }
    return translated;
};

export default StringResource;
